/**
 * Search results: add single-variant products to cart from .js-search-atc buttons.
 * Loaded once per search results page (see templates/search.liquid).
 */
(function () {
  if (window.__searchAtcInitialized) {
    return;
  }
  window.__searchAtcInitialized = true;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.js-search-atc');
    if (!btn) {
      return;
    }

    const selectId = btn.getAttribute('data-uses-select');
    let variantId;

    if (selectId) {
      const select = document.getElementById(selectId);
      variantId = select ? select.value : btn.getAttribute('data-variant-id');
    } else {
      variantId = btn.getAttribute('data-variant-id');
    }

    if (!variantId) {
      return;
    }

    const addingText =
      btn.getAttribute('data-adding-text') || 'Adding…';

    btn.disabled = true;
    btn.textContent = addingText;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        const d = await res.json().catch(function () {
          return {};
        });
        throw new Error(d.description || 'Error');
      }

      await res.json();

      const originalText = btn.getAttribute('data-original-text');
      btn.textContent = 'Added to your cart';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);

      /**
       * Header bubbles use `.cartCount` (nav-contents.liquid); `.cartCost` mirrors theme.js.
       */
      const syncHeaderCartUi = function (cart) {
        const itemCount = cart.item_count;

        document
          .querySelectorAll('.cartCount, .CartCount, .cart-count, [data-cart-count]')
          .forEach(function (el) {
            el.textContent = String(itemCount);
            el.classList.toggle('hidden-count', itemCount < 1);
          });

        document.querySelectorAll('.cartCost').forEach(function (el) {
          if (itemCount === 0) {
            el.classList.add('hidden-count');
          } else {
            el.innerHTML = "(<span class='cart-count'>" + itemCount + "</span>)";
            el.classList.remove('hidden-count');
          }
        });
      };

      if (typeof window.updateCartCount === 'function') {
        window.updateCartCount();
      } else {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        syncHeaderCartUi(cart);
      }
    } catch (err) {
      btn.textContent = btn.getAttribute('data-original-text');
      btn.disabled = false;
      console.error('Search ATC error:', err);
    }
  });
})();
